
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"
import { Armchair} from "lucide-react";

const seatBadgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200",
        secondary:
          "border-transparent bg-purple-100 text-purple-800 hover:bg-purple-200",
        business:
          "border-transparent bg-amber-100 text-amber-800 hover:bg-amber-200",
        economy:
          "border-transparent bg-green-100 text-green-800 hover:bg-green-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface SeatBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof seatBadgeVariants> {
    seatNumber: string;
}

function SeatBadge({ className, variant, seatNumber, ...props }: SeatBadgeProps) {
  return (
    <div className={cn(seatBadgeVariants({ variant }), className)} {...props}>
      <Armchair className="w-6 h-6 text-black-500" />
      <span>{seatNumber}</span>
    </div>
  )
}

export { SeatBadge, seatBadgeVariants }
